// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"22":"2319bcbb","54":"1f933f2a","70":"c78fffd7","101":"77fe7ecd","286":"6581a8f4","943":"ad7e5d08"}[chunkId] + ".css";
};